module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " \u304B\u3089 ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " \u3092\u9078\u629E");
  },
  "finishRangeSelectionPrompt": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u65E5\u4ED8\u7BC4\u56F2\u306E\u9078\u629E\u3092\u7D42\u4E86",
  "maximumDate": "\u6700\u7D42\u5229\u7528\u53EF\u80FD\u65E5",
  "minimumDate": "\u6700\u521D\u306E\u5229\u7528\u53EF\u80FD\u65E5",
  "next": "\u6B21\u3078",
  "previous": "\u524D\u3078",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u9078\u629E\u3057\u305F\u65E5\u4ED8 : ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u9078\u629E\u7BC4\u56F2 : ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u65E5\u4ED8\u7BC4\u56F2\u306E\u9078\u629E\u3092\u958B\u59CB",
  "todayDate": function todayDate(args) {
    return "\u672C\u65E5\u3001".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "\u672C\u65E5\u3001".concat(args.date, " \u3092\u9078\u629E");
  }
};